import { useEffect, useState } from 'react';
import Router from 'next/router';
import useMediaQuery from '@mui/material/useMediaQuery';
import Footer from '../General/Footer';
import Header from '../Header/Header';
import { getUser } from '../../helpers/token';
import { LOGGED_OUT_NAV_ITEMS, NAV_ROUTES } from '../General/loggedOutNav';
import ArticleNav from '../Post/Article/ArticleNav';
import BottomNavigation from '../Dashboard/BottomNavigation';

// Shared page chrome for the destinations section, topic and badge pages.
// Static pages can't know the auth cookie, so the reading nav (with its
// signup CTA) is what search visitors get in the SSR HTML; members see
// the familiar app Header as soon as the page hydrates.
export default function DestinationShell({
  headerProps,
  bottomNavValue = 2,
  navOverPhoto,
  children,
}) {
  const [isMember, setIsMember] = useState(false);
  useEffect(() => {
    if (getUser()) setIsMember(true);
  }, []);

  // Warm paper behind everything — same as post and author pages.
  useEffect(() => {
    document.body.classList.add('tf-paper');
    return () => document.body.classList.remove('tf-paper');
  }, []);

  const isMobileView = useMediaQuery('(max-width: 991px)');

  return (
    <>
      {isMember ? (
        // Over a photo hero the Header floats transparent with no spacer,
        // matching the ArticleNav geometry so the swap on hydration doesn't
        // shift the page.
        <Header
          {...headerProps}
          isScrollingNav={navOverPhoto}
          noSpacer={navOverPhoto}
        />
      ) : (
        <>
          <ArticleNav overPhoto={navOverPhoto} />
          {isMobileView && (
            <BottomNavigation
              navItems={LOGGED_OUT_NAV_ITEMS}
              value={bottomNavValue}
              handleChange={(event, newValue) =>
                Router.push({ pathname: NAV_ROUTES[newValue] })
              }
            />
          )}
        </>
      )}
      {children}
      <Footer />
    </>
  );
}
